import React from 'react';

const SearchResultsSkeleton: React.FC = () => {
  return (
    <section className="snap-start">
      <div className="flex flex-col md:flex-row h-auto transition-opacity duration-500 md:h-72 lg:h-72 w-auto sm:h border border-gray-200 rounded-lg overflow-hidden shadow-lg my-4 animate-pulse">
        {/* Image container */}
        <div className="md:w-1/3 bg-gray-300 h-60 md:h-full"></div>

        {/* Text container */}
        <div className="flex-grow md:w-1/3 p-4 space-y-4 flex flex-col justify-between">
          <div className="flex items-center mb-2 space-x-2">
            <div className="flex">
              {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="w-5 h-5 bg-gray-300 rounded-full"></div>
              ))}
            </div>
            <div className="ml-1 w-16 h-5 bg-gray-300 rounded"></div>
          </div>
          <div className="w-3/4 h-6 bg-gray-300 rounded"></div>
          <div className="flex flex-wrap gap-1 my-2">
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="bg-gray-300 text-xs font-semibold px-2 py-1 rounded w-16 h-5"></div>
            ))}
            <div className="text-xs text-gray-500 w-10 h-5 bg-gray-300 rounded"></div>
          </div>
        </div>

        {/* Price and button container */}
        <div className="flex-none p-4 md:border-l md:w-1/4 space-y-4 flex flex-col justify-between">
          <div className="flex justify-center h-6 font-thin text-sm text-halo-pink pt-1 bg-gray-300 rounded"></div>
          <div className="flex justify-center my-10  w-16 h-16 rounded-full"></div>
          <div className="flex justify-center mt- text-lg font-bold w-16 h-6 bg-gray-300 rounded"></div>
          <div className="flex justify-center block text-sm text-gray-500 w-24 h-5 bg-gray-300 rounded"></div>
          <div className="flex justify-center mx-10 mt-2 bg-gray-300 text-white py-2 text-sm font-semibold rounded"></div>
        </div>
      </div>
    </section>
  );
};

export default SearchResultsSkeleton;
